export default function initGalleryLighbox() {
  const createLightbox = () => {
    const lightbox = document.createElement("div");
    lightbox.className = "gallery-lightbox";
    lightbox.innerHTML = `
      <button class="gallery-lightbox-close" tabindex="0" aria-label="Zamknij">&times;</button>
      <div class="gallery-lightbox-content">
        <img class="gallery-lightbox-image" src="" alt="">
        <div class="gallery-lightbox-counter"></div>
        <button class="gallery-lightbox-nav gallery-lightbox-prev" tabindex="0" aria-label="Poprzednie zdjęcie">&lsaquo;</button>
        <button class="gallery-lightbox-nav gallery-lightbox-next" tabindex="0" aria-label="Następne zdjęcie">&rsaquo;</button>
      </div>
      <div class="gallery-lightbox-thumbnails"></div>
    `;
    document.body.appendChild(lightbox);

    return {
      container: lightbox,
      image: lightbox.querySelector(".gallery-lightbox-image"),
      close: lightbox.querySelector(".gallery-lightbox-close"),
      prev: lightbox.querySelector(".gallery-lightbox-prev"),
      next: lightbox.querySelector(".gallery-lightbox-next"),
      counter: lightbox.querySelector(".gallery-lightbox-counter"),
      thumbnailsContainer: lightbox.querySelector(
        ".gallery-lightbox-thumbnails"
      ),
    };
  };

  const initialize = () => {
    const lightbox = createLightbox();

    const galleries = document.querySelectorAll(".wp-block-gallery");

    galleries.forEach((gallery) => {
      const images = Array.from(gallery.querySelectorAll("img"));

      images.forEach((img, index) => {
        img.setAttribute("tabindex", "0");
        img.setAttribute("role", "button");
        img.setAttribute(
          "aria-label",
          `Otwórz zdjęcie ${index + 1} z ${images.length}`
        );

        img.addEventListener("click", function (e) {
          e.preventDefault();
          openLightbox(images, index);
        });

        img.addEventListener("keydown", function (e) {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            openLightbox(images, index);
          }
        });
      });
    });

    function openLightbox(images, index) {
      let currentIndex = index;
      lightbox.close.setAttribute("tabindex", "0");
      lightbox.prev.setAttribute("tabindex", "0");
      lightbox.next.setAttribute("tabindex", "0");

      function generateThumbnails() {
        lightbox.thumbnailsContainer.innerHTML = "";

        images.forEach((img, idx) => {
          const thumbnail = document.createElement("img");
          thumbnail.className = "gallery-lightbox-thumbnail";
          thumbnail.src = img.getAttribute("src");
          thumbnail.alt = img.getAttribute("alt") || "";
          thumbnail.dataset.index = idx;
          thumbnail.setAttribute("tabindex", "0");
          thumbnail.setAttribute("role", "button");
          thumbnail.setAttribute(
            "aria-label",
            `Wybierz zdjęcie ${idx + 1} z ${images.length}`
          );

          if (idx === currentIndex) {
            thumbnail.classList.add("active");
          }

          thumbnail.addEventListener("click", () => {
            currentIndex = parseInt(thumbnail.dataset.index);
            updateImage();
          });

          thumbnail.addEventListener("keydown", (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              currentIndex = parseInt(thumbnail.dataset.index);
              updateImage();
            }
          });

          lightbox.thumbnailsContainer.appendChild(thumbnail);
        });

        const activeThumbnail = lightbox.thumbnailsContainer.querySelector(
          ".gallery-lightbox-thumbnail.active"
        );
        if (activeThumbnail) {
          activeThumbnail.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center",
          });
        }
      }

      function updateImage() {
        const currentImg = images[currentIndex];
        const imgSrc = currentImg.getAttribute("src");
        const imgAlt = currentImg.getAttribute("alt") || "";

        lightbox.image.setAttribute("src", imgSrc);
        lightbox.image.setAttribute("alt", imgAlt);
        lightbox.counter.textContent = `${currentIndex + 1} / ${images.length}`;

        lightbox.image.setAttribute(
          "aria-label",
          `Zdjęcie ${currentIndex + 1} z ${images.length}`
        );

        const thumbnails = lightbox.thumbnailsContainer.querySelectorAll(
          ".gallery-lightbox-thumbnail"
        );
        thumbnails.forEach((thumb) => {
          thumb.classList.remove("active");
          if (parseInt(thumb.dataset.index) === currentIndex) {
            thumb.classList.add("active");
            thumb.scrollIntoView({
              behavior: "smooth",
              block: "nearest",
              inline: "center",
            });

            thumb.focus();
          }
        });

        if (currentIndex < images.length - 1) {
          const nextImg = new Image();
          nextImg.src = images[currentIndex + 1].getAttribute("src");
        }
        if (currentIndex > 0) {
          const prevImg = new Image();
          prevImg.src = images[currentIndex - 1].getAttribute("src");
        }
      }

      generateThumbnails();

      updateImage();
      lightbox.container.classList.add("active");
      lightbox.close.focus();

      function handleKeyDown(e) {
        if (e.key === "Escape") {
          closeLightbox();
        } else if (e.key === "ArrowLeft") {
          showPrevImage();
        } else if (e.key === "ArrowRight") {
          showNextImage();
        } else if (e.key === "Tab") {
          const focusableElements = lightbox.container.querySelectorAll(
            'button, [tabindex="0"]'
          );
          const firstElement = focusableElements[0];
          const lastElement = focusableElements[focusableElements.length - 1];

          if (e.shiftKey && document.activeElement === firstElement) {
            e.preventDefault();
            lastElement.focus();
          } else if (!e.shiftKey && document.activeElement === lastElement) {
            e.preventDefault();
            firstElement.focus();
          }
        }
      }

      document.addEventListener("keydown", handleKeyDown);

      function closeLightbox() {
        lightbox.container.classList.remove("active");
        document.removeEventListener("keydown", handleKeyDown);

        const originalImage = images[currentIndex];
        if (originalImage) {
          originalImage.focus();
        }
      }

      function showPrevImage() {
        if (currentIndex > 0) {
          currentIndex--;
          updateImage();
        }
      }

      function showNextImage() {
        if (currentIndex < images.length - 1) {
          currentIndex++;
          updateImage();
        }
      }

      lightbox.close.addEventListener("click", closeLightbox);
      lightbox.close.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          closeLightbox();
        }
      });

      lightbox.prev.addEventListener("click", showPrevImage);
      lightbox.prev.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          showPrevImage();
        }
      });

      lightbox.next.addEventListener("click", showNextImage);
      lightbox.next.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          showNextImage();
        }
      });

      lightbox.container.addEventListener("click", function (e) {
        if (e.target === lightbox.container) {
          closeLightbox();
        }
      });
    }
  };

  // Uruchom inicjalizację po załadowaniu DOM
  document.addEventListener("DOMContentLoaded", initialize);

  // Zwróć publiczne metody (jeśli są potrzebne)
  return {
    init: initialize,
  };
}
